import { Component, Mixins } from "vue-property-decorator";
import DigitalSignCurrentCompany from '@/feature/Auth/mixins/DigitalSignCurrentCompany';
import PaymentRequirementsIncomingSignData from "./PaymentRequirementsIncomingSignData";
import { PaymentRequirementsIncomingStore } from "../../../store/incoming";
import { PaymentRequirementsIncomingAction } from "../../../store/incoming/constants";
import { DigitalSignCommonData } from "@/mixins/crk/interface";
import { PaymentRequirementsIncomingSignResponse } from "../../../api/incoming/payment-requirements-incoming.interface";

@Component
export default class PaymentRequirementsIncomingSign extends Mixins(
	DigitalSignCurrentCompany,
	PaymentRequirementsIncomingSignData
) {

	@PaymentRequirementsIncomingStore.Action(
		PaymentRequirementsIncomingAction.signUnprocessed
	)
	signUnprocessedPaymentRequirements!: (_payload: DigitalSignCommonData) =>
		Promise<PaymentRequirementsIncomingSignResponse | null>

	signPaymentRequirementsIncoming() {
		this.signData(this.getPaymentRequirementsDataForSign());
	}

}